import { format, parse } from 'date-fns';

export const formatISOTimeForDisplay = (timeString: string, formatString = 'H:mm'): string => {
    try {
        const date = parse(timeString, 'HH:mm:ss', new Date());
        return format(date, formatString);
    } catch (e) {
        console.error('Error formatting time', e);
        return timeString;
    }
};
